export default function MapPinIcon() {
  return (
    <svg
      width="28"
      height="38"
      viewBox="0 0 28 38"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M14.0004 0C6.41194 0 0.238281 6.17366 0.238281 13.7621C0.238281 23.1796 12.5541 37.0049 13.0784 37.5889C13.5709 38.1375 14.4308 38.1365 14.9225 37.5889C15.4468 37.0049 27.7626 23.1796 27.7626 13.7621C27.7625 6.17366 21.5889 0 14.0004 0ZM14.0004 20.6862C10.1825 20.6862 7.07642 17.58 7.07642 13.7621C7.07642 9.94412 10.1826 6.83807 14.0004 6.83807C17.8183 6.83807 20.9244 9.9442 20.9244 13.7622C20.9244 17.5801 17.8183 20.6862 14.0004 20.6862Z"
        fill="#FF3939"
      />
    </svg>
  );
}
